import { PriceContext } from "../context";
import { useContext } from "react";


export function useAppContext(){
    return useContext(PriceContext)
}
